<script>
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import MarkedContent from "./MarkedContent.svelte";

	export let services;
	export let servicesContentClass = "mb-6";
</script>

{#each services as service}
	<div class="flex gap-4 w-full">
		<div class="w-16 text-color">
			<SvelteFa icon={service.icon} size="2x" class="mx-auto" />
		</div>
		<div class="w-full">
			{#if service.title}
				<h3 class="mb-2">
					{service.title}
				</h3>
			{/if}
			<div class="text-xl">
				{#each service.content as content}
					{#if service.isIdentifier}
						<div dir="ltr">
							<MarkedContent
								markedContent={content}
								class={servicesContentClass}
							/>
						</div>
					{:else}
						<MarkedContent
							markedContent={content}
							class={servicesContentClass}
						/>
					{/if}
				{/each}
			</div>
		</div>
	</div>
{/each}
